<app-dialog-header
  [title]="data.title"
  (close)="dialogRef.close()"
/>

<div
  style="
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1rem;
  "
>
  @if (data.description != null) {
    <div>{{ data.description }}</div>
  }

  @if (data.email) {
    <div>{{ data.email }}</div>
  }

  @if (data.showCustomCheckBox) {
    <div>
      <kpi4me-checkbox-element
        [displayAs]="'toggle'"
        [label]="data.checkBoxText"
        [formControlElement]="checkBoxValue"
      />
    </div>
  }

  @if (isSecurityPhraseRequired) {
    <ng-container>
      <div style="margin-top: 1rem; text-align: center;">
        Um fortzufahren, geben Sie <strong>{{ data.securityPhrase }}</strong> ein.
      </div>
      <mat-form-field style="margin-top: 0.5rem; width: 100%;">
        <mat-label>Sicherheitsphrase</mat-label>
        <input
          matInput
          [formControl]="securityPhraseControl"
          [placeholder]="data.securityPhrase"
          autocomplete="off"
        />
      </mat-form-field>
    </ng-container>
  }
</div>

<mat-dialog-actions style="margin-top: 20px">
  <div style="display: flex">
    <app-confirm-icon-button
      (customClick)="onConfirm()"
      [matTooltip]="data.confirmButtonText"
      [disabled]="isConfirmDisabled"
    />

    <app-cancel-icon-button
      style="margin-left: 1rem;"
      (click)="onCancel()"
      [matTooltip]="data.cancelButtonText"
    />
  </div>
</mat-dialog-actions>
